module.exports = __webpack_public_path__ + "static/img/cont55 (1).7f7c891.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont55 (1).jpg
// module id = 0Tqg
// module chunks = 0